import { Badge, BadgeSize, BadgeVariant } from "@/components/ui/Badge";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { useTruncatedList } from "@/hooks/useTruncatedList";

interface TruncatedRolesBadgesProps {
  roles: string[];
}

export const TruncatedRolesBadges = ({ roles }: TruncatedRolesBadgesProps) => {
  const { containerRef, measureRef, visibleCount, hiddenCount } = useTruncatedList({
    itemCount: roles.length,
  });

  if (roles.length === 0) {
    return null;
  }

  return (
    <div ref={containerRef} className="relative flex w-full min-w-0 flex-1 items-center gap-1">
      <div
        ref={measureRef}
        className="pointer-events-none invisible absolute flex w-full gap-1"
        aria-hidden="true"
      >
        {roles.map(role => (
          <Badge key={role} variant={BadgeVariant.GRAY} size={BadgeSize.SM}>
            {role}
          </Badge>
        ))}
      </div>
      {roles.slice(0, visibleCount).map(role =>
        hiddenCount > 0 ? (
          <BasicTooltip key={role} content={role}>
            <span>
              <Badge variant={BadgeVariant.GRAY} size={BadgeSize.SM} className="hover:bg-gray-200">
                {role}
              </Badge>
            </span>
          </BasicTooltip>
        ) : (
          <Badge
            key={role}
            variant={BadgeVariant.GRAY}
            size={BadgeSize.SM}
            className="hover:bg-gray-200"
          >
            {role}
          </Badge>
        ),
      )}
      {hiddenCount > 0 && (
        <BasicTooltip content={roles.slice(visibleCount).join(", ")}>
          <span>
            <Badge variant={BadgeVariant.GRAY} size={BadgeSize.SM}>
              +{hiddenCount}
            </Badge>
          </span>
        </BasicTooltip>
      )}
    </div>
  );
};
